import { useAppSelector } from "@/store/hooks";
import useSetActivity from "@/hooks/useSetActivity";
import useUpdateWorkflowStatus from "@/hooks/useUpdateWorkflowStatus";
import useSetWorkflowState from "@/hooks/useSetWorkflowState";
import { WizardStep } from "@/store";
import ReactMarkdownExtended from "./ReactMarkdownExtended";
import { Session } from "@/store/features/wizardSlice";
import { GoArrowRight } from "react-icons/go";

const buildReturnUrl = (
  orderformurl: string | undefined,
  session: Session,
  step: WizardStep,
) => {
  const { deal, uuid } = session || {};
  console.log("Orderform session", session, { deal, uuid });
  console.log("orderform step", step);
  console.log("orderform deal", session.deal);

  const successUrl = new URL(String(process.env.NEXT_PUBLIC_URL));
  successUrl.searchParams.set("sessionId", String(uuid));
  successUrl.searchParams.set("success", String(step.order)); // really, index+1

  const failUrl = new URL(String(process.env.NEXT_PUBLIC_URL));
  failUrl.searchParams.set("sessionId", String(uuid));
  // not adding success = should pick up where left

  console.log("successUrl", successUrl.toString());
  console.log("failUrl", failUrl.toString());

  const url = new URL(String(orderformurl));
  if (session.deal) {
    url.searchParams.set("deal", session.deal);
  }
  url.searchParams.set("query_success", successUrl.toString());
  url.searchParams.set("query_fail", failUrl.toString());

  return url.toString();
};

// eslint-disable-next-line no-unused-vars
export default function Orderform({ step }: { step: WizardStep }) {
  const {
    markdown = "# Payment\nLet's get this out of the way",
    orderformurl,
  } = step || {};

  const session = useAppSelector((state) => state.wizard.session);
  const state = useAppSelector((state) => state.wizard);

  useSetActivity("orderform", session.id);
  useUpdateWorkflowStatus("loaded", session.workflowId);
  useSetWorkflowState(session.workflowId, state as any);

  // const dispatch = useAppDispatch();
  // useEffect(() => {
  //   // there isn't much to actually do on the welcome page to "complete" it
  //   const cursteps = state?.steps || ({} as any);
  //   const key = String(state?.stepNumber);
  //   // console.log("we done already? prevent loop", key, cursteps[key]?.done);
  //   if (key && !cursteps[key]?.done) {
  //     console.log(
  //       "orderform useEffect: if this was a welcome page, we'd set done to true here. But we're not, so customer must pay and redirect back here",
  //     );
  //     // dispatch(setStepState({ step: state.stepNumber, data: { done: true } }));
  //   }
  // }, [state, dispatch]);

  // build return url
  const annotatedUrl = buildReturnUrl(orderformurl, session, step);

  return (
    <div className="mt-14 md:mt-32">
      <div className="mx-auto w-full sm:w-3/4 my-10">
        <div className="flex justify-center mb-10">
          <ReactMarkdownExtended content={markdown} />
        </div>

        <button
          type="button"
          className={
            "group/next mx-auto rounded-sm w-3/4 md:w-96 py-2 text-md font-semibold text-white flex items-center justify-center gap-1 shadow-lg bg-primary hover:bg-primary/90 animate-pulse"
          }
          onClick={() => (window.location.href = annotatedUrl)}
        >
          View My Payment Options
          <GoArrowRight
            className={"group-hover/next:translate-x-1 transition-all"}
          />
        </button>
        {/* <Link href={annotatedUrl} className="text-blue-500">
          Lesgoo! Link or button goes here
        </Link>{" "}
        we could also send the user directly there :thinking_face: */}
      </div>
    </div>
  );
}
